import type { RoomCredentials } from "../types";

const LOCAL_PAIR_KEY = "cue-studio-local-pair-v1";

/** One tab-session record; a different room, capability or relay never matches. */
export function hasRememberedLocalDisplay(credentials: RoomCredentials): boolean {
  if (!credentials.relayUrl) return false;
  try {
    const saved = JSON.parse(sessionStorage.getItem(LOCAL_PAIR_KEY) || "null");
    return saved?.roomId === credentials.roomId && saved?.token === credentials.token &&
      saved?.relayUrl === credentials.relayUrl;
  } catch {
    return false;
  }
}

/** Called once when this operator actually hears a local talent display. */
export function rememberLocalDisplay(credentials: RoomCredentials): boolean {
  if (!credentials.relayUrl) return false;
  try {
    sessionStorage.setItem(LOCAL_PAIR_KEY, JSON.stringify({
      roomId: credentials.roomId, token: credentials.token, relayUrl: credentials.relayUrl,
    }));
    return true;
  } catch {
    return false;
  }
}
